export default __webpack_public_path__ + "static/media/robocon1.11e0cd10.jpg";